import { render, staticRenderFns } from "./OrkProductGallery.html?vue&type=template&id=27fb5ef7&scoped=true&"
import script from "./OrkProductGallery.vue?vue&type=script&lang=js&"
export * from "./OrkProductGallery.vue?vue&type=script&lang=js&"
import style0 from "./OrkProductGallery.scss?vue&type=style&index=0&id=27fb5ef7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fb5ef7",
  null
  
)

export default component.exports